import React, { useRef, useEffect } from 'react';
import './ShinyButton.css';

interface ShinyButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
  }

  const ShinyButton: React.FC<ShinyButtonProps> = ({
    children,
    onClick,
    type = 'button',
    disabled = false,
}) => {

    const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const injectGlobalStyles = () => {
      const style = document.createElement('style');
      style.textContent = `
        @property --gradient-angle {
          syntax: "<angle>";
          initial-value: 0deg;
          inherits: false;
        }

        @property --gradient-angle-offset {
          syntax: "<angle>";
          initial-value: 0deg;
          inherits: false;
        }

        @property --gradient-percent {
          syntax: "<percentage>";
          initial-value: 5%;
          inherits: false;
        }

        @property --gradient-shine {
          syntax: "<color>";
          initial-value: white;
          inherits: false;
        }
      `;
      document.head.appendChild(style);
    };

    injectGlobalStyles();
  }, []);

  return (
    <button
      ref={buttonRef}
      className="shiny-cta"
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      <span>{children}</span>
    </button>
  );
};

export default ShinyButton;